export const MAINTENANCE_NOTICE_START = Date.parse("2026-10-20T00:00:00+09:00")
export const MAINTENANCE_NOTICE_END = Date.parse("2026-10-23T14:00:00+09:00")
export const MAINTENANCE_NOTICE_STORAGE_KEY = "reviewed:maintenance:2026-10-20-23:hidden-date"

export const getKoreanDateKey = (now: number) =>
  new Date(now + 9 * 60 * 60 * 1000).toISOString().slice(0, 10)

export const shouldShowMaintenanceNotice = (now: number, hiddenDate: string | null) =>
  now >= MAINTENANCE_NOTICE_START
  && now < MAINTENANCE_NOTICE_END
  && hiddenDate !== getKoreanDateKey(now)
